import React, { Component } from 'react';

const TableHead = () => (
    <thead className="thead-light">
        <tr>
            <th scope="col">Protocolo</th>
            <th scope="col">NSU</th>
            <th scope="col">Data</th>
            <th scope="col">Bandeira</th>
            <th scope="col">Cartão Truncado</th>
            <th scope="col">Tipo</th>
            <th scope="col">Valor</th>
            <th scope="col">Plano</th>
            {/* <th scope="col">Terminal</th> */}
            <th scope="col">Status</th>
            <th scope="col"></th>
        </tr>
    </thead>
);

export default TableHead;



// WEBPACK FOOTER //
// ./src/components/Pages/Payments/Table/TableHead.js